module.exports = __webpack_public_path__ + "img/status-3-glow.8db9dd4b.png";